export const lastIndex = (array: any[]): number => {
  return array.length - 1;
};
